/**
 * Centralized react-query key registry.
 * Keys are typed arrays so structural comparison works correctly.
 */

export const queryKeys = {
  // Broker
  walletBalance: () => ['walletBalance'] as const,
  walletTransactions: (params: { page: number; limit: number }) =>
    ['walletTransactions', params] as const,

  // Auth
  authMe: () => ['authMe'] as const,
  nafathInitiate: (refetchKey: number) => ['nafathInitiate', refetchKey] as const,

  // Broker — profile + transactions
  brokerProfile: () => ['brokerProfile'] as const,
  brokerTransaction: (id: string | null) => ['brokerTransaction', id] as const,
  brokerTransactions: (params: Record<string, unknown>) => ['brokerTransactions', params] as const,
  dealActivity: (id: string | null) => ['dealActivity', id] as const,
  brokerList: (params: Record<string, unknown>) => ['brokerList', params] as const,

  // Wallet
  withdrawals: (params?: { status?: string; page?: number; limit?: number }) =>
    ['withdrawals', params] as const,

  // Payer
  payerDeal: (id: string | null) => ['payerDeal', id] as const,

  // Geo
  saudiRegions: () => ['saudiRegions'] as const,
  saudiCities: (regionId: string | null) => ['saudiCities', regionId] as const,
  saudiDistricts: (cityId: string | null) => ['saudiDistricts', cityId] as const,
} as const;
